<script>
export default {
  props: {
    markRequired: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<template>
  <div :class="$style.labelMargin">
    <slot></slot>
    <span v-if="markRequired" class="text-danger">*</span>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.labelMargin {
  margin-top: 0.625rem 0;
  font-size: $size-font-sub-header;
  font-weight: $heading-font-weight;
  color: $color-subheader;
}
</style>
